import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { Modal } from "@/models/Modal";
import useModal from "@/hooks/useModal";
import modalComponents from "@/views/modals/context/index";
import BaseModal from "@/views/modals/BaseModal.vue";
import { ref, PropType, Component } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalLinks',
  props: {
  modals: {
    type: Array as PropType<Modal[]>,
    default: () => [],
  },
  title: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const modalPath = ref("");
const activeModal = ref();
const { toggleModal } = useModal();
// const activeModal = computed(() => {
//   if (modalPath.value) {
//     const modalComp = defineAsyncComponent(
//       () => import(`@/views/modals/${modalPath.value}`)
//     );
//     return modalComp;
//   }
//   return null;
// });
// const activeModal = defineAsyncComponent(
//   () => import("../modals/HiTest.vue")
// );

// const importModal = (modal: string) => {
//   return defineAsyncComponent(
//     () => import(`@/views/modals/${modalPath.value}`)
//   );
// return () => import(`@/views/modals/HiTest.vue`);
//};
// const importModal = (modal: string) => {

// };
// const showCovered = (modalName: string) => {
// modalPath.value = modalPathE;
// activeModal.value = importModal(modalPathE);
// console.log(activeModal.value);
// };
// const mods = props.modals.filter((item) => {
//   return (item.label = item.label + props.title);
// });
// console.log(props);
const getModuleComponent = (path: string): Component | null => {
  const module: { name: string; component: Component } | undefined =
    modalComponents.find((e: { name: string; component: Component }) =>
      path.includes(e.name)
    );
  return module?.component ? module.component : null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modals, (modal) => {
    return (_openBlock(), _createElementBlock("div", {
      key: modal.label,
      class: "mod"
    }, [
      _createElementVNode("a", {
        class: "menua",
        onClick: ($event: any) => (_unref(toggleModal)(modal.label, __props.title))
      }, _toDisplayString(modal.label), 9, _hoisted_1),
      _createVNode(BaseModal, {
        name: modal.label,
        class: _normalizeClass(__props.title),
        title: __props.title
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(getModuleComponent(modal.path))))
        ]),
        _: 2
      }, 1032, ["name", "class", "title"])
    ]))
  }), 128))
}
}

})